<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button mode="md" defaultHref="/settings/pos-settings"></ion-back-button>
    </ion-buttons>
    <ion-title>Discounts</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-row>
    <ion-col class="hidden-sm-down"></ion-col>

    <ion-col size="12" size-sm="12" size-md="8" size-lg="8" size-xl="8">
      <ion-list>
        <ion-item routerLink="./salon-discounts"> Salon Discounts </ion-item>
        <ion-item lines="none" routerLink="./stylist-discounts"> Stylist Discounts </ion-item>
      </ion-list>
    </ion-col>

    <ion-col class="hidden-sm-down"></ion-col>
  </ion-row>
</ion-content>
